module.exports = __webpack_public_path__ + "img/ln1.6e13793c.png";